var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDialogGraph = function SvgDialogGraph(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441.5,
    height: 167,
    viewBox: "0 0 441.5 167",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing_-_graph",
    "data-name": "landing - graph",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    transform: "translate(40 1)",
    fill: "#eee",
    stroke: "#65a844",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 165,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 397,
    height: 162,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 393,
    transform: "translate(43.5 46.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 393,
    transform: "translate(43.5 84.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 393,
    transform: "translate(43.5 123.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_5",
    "data-name": "Intersection 5",
    d: "M-2981,111.968a4.5,4.5,0,0,1-4.5-4.414V34.093h35.306l12.01,3.489c3,.872,15.008-3.489,15.008-3.489l34.635,3.489h46.8l39.314,3.528,33.365,6.211,44.731-6.211,18.674,22.766h44.065l13.406,18.448,28.741,6.659,24.627,2.69H-2586v15.794a4.5,4.5,0,0,1-4.5,4.5Z",
    transform: "translate(3026 53.407)",
    fill: "rgba(101,168,68,0.2)",
    stroke: "#65a844",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    id: "_10_kW",
    "data-name": "10 kW",
    transform: "translate(16 10)",
    fill: "#4d4d4f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.938,
    y: 0
  }, "10 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_5_kW",
    "data-name": "5 kW",
    transform: "translate(18 87)",
    fill: "#4d4d4f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.096,
    y: 0
  }, "5 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_7.5_kW",
    "data-name": "7.5 kW",
    transform: "translate(15 49)",
    fill: "#4d4d4f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.334,
    y: 0
  }, "7.5 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_0_kW",
    "data-name": "0 kW",
    transform: "translate(18 164)",
    fill: "#4d4d4f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.096,
    y: 0
  }, "0 kW")), /*#__PURE__*/React.createElement("text", {
    id: "_2.5_kW",
    "data-name": "2.5 kW",
    transform: "translate(15 126)",
    fill: "#4d4d4f",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.334,
    y: 0
  }, "2.5 kW")), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 393,
    y2: 5.5,
    transform: "translate(43.5 84)",
    fill: "none",
    stroke: "#25556e",
    strokeWidth: 1,
    strokeDasharray: "2 1"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDialogGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dialog_graph.260ed9bcba5b85d5508f5cd40068803e.svg";